"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _timing = _interopRequireDefault(require("@/api/system/timing"));

var _log = _interopRequireDefault(require("./log"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _DateRangePicker = _interopRequireDefault(require("@/components/DateRangePicker"));

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {
  id: null,
  jobName: null,
  subTask: null,
  beanName: null,
  methodName: null,
  params: null,
  cronExpression: null,
  pauseAfterFailure: true,
  isPause: false,
  personInCharge: null,
  email: null,
  description: null
};
var _default = {
  name: 'Timing',
  components: {
    Log: _log.default,
    pagination: _Pagination.default,
    crudOperation: _CRUD.default,
    rrOperation: _RR.default,
    DateRangePicker: _DateRangePicker.default
  },
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '定时任务',
      url: 'api/jobs',
      crudMethod: _objectSpread({}, _timing.default)
    });
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  data: function data() {
    return {
      delLoading: false,
      permission: {
        add: ['admin', 'timing:add'],
        edit: ['admin', 'timing:edit'],
        del: ['admin', 'timing:del']
      },
      rules: {
        jobName: [{
          required: true,
          message: '请输入任务名称',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          message: '请输入任务描述',
          trigger: 'blur'
        }],
        beanName: [{
          required: true,
          message: '请输入Bean名称',
          trigger: 'blur'
        }],
        methodName: [{
          required: true,
          message: '请输入方法名称',
          trigger: 'blur'
        }],
        cronExpression: [{
          required: true,
          message: '请输入Cron表达式',
          trigger: 'blur'
        }],
        personInCharge: [{
          required: true,
          message: '请输入负责人名称',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    // 执行
    execute: function execute(id) {
      var _this = this;

      _timing.default.execution(id).then(function (res) {
        _this.crud.notify('执行成功', _crud.default.NOTIFICATION_TYPE.SUCCESS);
      }).catch(function (err) {
        console.log(err.response.data.message);
      });
    },
    // 改变状态
    updateStatus: function updateStatus(id, status) {
      var _this2 = this;

      if (status === '恢复') {
        this.updateParams(id);
      }

      _timing.default.updateIsPause(id).then(function (res) {
        _this2.crud.toQuery();

        _this2.crud.notify(status + '成功', _crud.default.NOTIFICATION_TYPE.SUCCESS);
      }).catch(function (err) {
        console.log(err.response.data.message);
      });
    },
    updateParams: function updateParams(id) {
      console.log(id);
    },
    delMethod: function delMethod(id) {
      var _this3 = this;

      this.delLoading = true;

      _timing.default.del([id]).then(function () {
        _this3.delLoading = false;

        _this3.$refs[id].doClose();

        _this3.crud.dleChangePage(1);

        _this3.crud.delSuccessNotify();

        _this3.crud.toQuery();
      }).catch(function () {
        _this3.delLoading = false;

        _this3.$refs[id].doClose();
      });
    },
    // 显示日志
    doLog: function doLog() {
      this.$refs.log.dialog = true;
      this.$refs.log.doInit();
    },
    checkboxT: function checkboxT(row, rowIndex) {
      return row.id !== 1;
    }
  }
};
exports.default = _default;